import React from 'react';
import DecodeImage from "../widgets/decode-image.jsx";

const defaultData = {
    "type": "share",
    "coverPic": "https://sta.dianvps.com/uploadfile/202503/1606803997.webp",
    "url":"/buy",
    "title": "买点",
    "text":"声音太骚7",
    "authorName": "Snap" ,
    "authorPic":"https://sta.dianvps.com/uploadfile/202503/1606803997.webp",
    "time": "2012-76-12"
}

const ShareCard = ({ data }) => {
    const {
        coverPic,
        url,
        title,
        text,
        authorName,
        authorPic,
        time
    } = {...defaultData, ...data};
    return (
        <div style={styles.card} onClick={() => window.open(url, '_blank')}>
            {coverPic &&
                <DecodeImage
                    src={coverPic} alt="cover" style={styles.cover} />}
            <div style={styles.title}>{title}</div>
            <div style={styles.body}>
                <div style={styles.text}>{text}</div>
            </div>
            <div style={styles.footer}>
                <DecodeImage src={authorPic} alt="author" style={styles.avatar} />
                <span style={styles.author}>{authorName}</span>
                <span style={styles.time}>{time || '刚刚'}</span>
            </div>
        </div>
    );
};

const styles = {
    card: {
        padding: 0,
        margin: '12px 0',
        overflow: 'hidden',
    },
    title: {
        fontWeight: 'bold',
        fontSize: 16,
        marginBottom: 8,
    },
    body: {
        display: 'flex',
        alignItems: 'center',
    },
    cover: {
        maxWidth: '100%',
        maxHeight: 200,
        marginRight: 12,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10
    },
    text: {
        fontSize: 14,
        flex: 1,
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 10,
    },
    avatar: {
        width: 24,
        height: 24,
        borderRadius: '50%',
        marginRight: 6,
    },
    author: {
        fontSize: 13,
        color: '#555',
    },
    time: {
        fontSize: 12,
        color: '#999',
        marginLeft: 'auto',
    }
};

export default ShareCard;
